<div class="outer-container" id="outer-container">
    <app-banner></app-banner>
    <router-outlet />
    <div id="footer" class="footer">
        <app-footer></app-footer>
    </div>
</div>

